// extracted by mini-css-extract-plugin
export default {"main_button":"MainButton_main_button__K5IWy","disabled":"MainButton_disabled__CCj1C"};